// Words for the Models page (screens/models/ModelsScreen.tsx): one version's facts in a line each. Pure, so tested.
import type { ModelVersionInfo } from "../api/ml";

const SIZE_NAMES: Record<string, string> = { n: "Nano", s: "Small", m: "Medium", l: "Large", x: "Extra large" };

const mb = (bytes: number) => `${Math.max(0.1, bytes / 1e6).toFixed(1)} MB`;

/** What the model is: "Nano · 640 px · outlines · Hailo · 6.2 MB". */
export function modelFacts(v: Pick<ModelVersionInfo, "model_size" | "img_size" | "corners" | "masks" | "hailo_safe" | "size_bytes">): string {
  const bits: string[] = [];
  if (v.model_size) bits.push(SIZE_NAMES[v.model_size] ?? v.model_size);
  if (v.img_size) bits.push(`${v.img_size} px`);
  bits.push(v.masks ? "outlines" : v.corners ? "boxes + corners" : "boxes");
  if (v.hailo_safe) bits.push("Hailo");
  if (v.size_bytes) bits.push(mb(v.size_bytes));
  return bits.join(" · ");
}

/** Where it came from: "120 images · 60 epochs · from v2", or "Imported: plant.pt". */
export function trainedOn(v: Pick<ModelVersionInfo, "source" | "imported_from" | "trained_on_count" | "epochs" | "warm_started_from_version"> & Pick<Partial<ModelVersionInfo>, "epochs_completed">): string {
  if (v.source === "imported") return `Imported: ${v.imported_from ?? "unknown file"}`;
  const bits: string[] = [];
  if (v.trained_on_count) bits.push(`${v.trained_on_count} image${v.trained_on_count === 1 ? "" : "s"}`);
  const epochs = typeof v.epochs_completed === "number" ? v.epochs_completed : v.epochs;
  if (epochs) bits.push(`${epochs} epochs`);
  if (v.warm_started_from_version) bits.push(`from v${v.warm_started_from_version}`);
  return bits.join(" · ") || "Trained";
}
